import store from '../../../../store';
export default function checkIfCanAdd() {
  let exists = false;
  let scopes = store.getters.userScopes;
  if (scopes.includes('system_company_add')) {
    exists = true;
  }
  return exists;
}
